import type { Prototype } from "../prototype-types";

export const wahabAhmadPrototypes: Prototype[] = [
  {
    id: "wa-shopify-pos-onboarding-hoverable-details",
    name: "Shopify POS onboarding hoverable details",
    path: "/wa/shopify-pos-onboarding-hoverable-details",
    description:
      "A first-step Shopify POS setup choice that keeps the decision concise and reveals supporting details through hoverable, keyboard-focusable info icons.",
    owner: "Wahab Ahmad",
    createdAt: "2026-08-24",
    lastUpdated: "2026-08-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "/images/thumbnails/wa-shopify-pos-onboarding-hoverable-details.png",
    creationTool: "cursor",
  },
  {
    id: "wa-savings-insights-2027",
    name: "Savings Insights 2027",
    path: "/wa/savings-insights-2027",
    description:
      "Five retailer-focused concepts for carrying savings momentum into a new year.",
    owner: "Wahab Ahmad",
    createdAt: "2026-08-26",
    lastUpdated: "2026-08-26",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/wa-savings-insights-2027.png",
    creationTool: "cursor",
  },
  {
    id: "wa-fd-marketplace-offer-checkout-banner",
    name: "FD Marketplace Offer Checkout Banner",
    path: "/wa/fd-marketplace-offer-checkout-banner",
    description:
      "Two post-checkout marketplace offer banner treatments that encourage retailers to shop another brand.",
    owner: "Wahab Ahmad",
    createdAt: "2026-09-09",
    lastUpdated: "2026-09-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    project: "Improve FD FOI Experience",
    thumbnail:
      "/images/thumbnails/wa-fd-marketplace-offer-checkout-banner.png",
  },
];
